import { Button, IconButton } from "@dropbox/dig-components/buttons";
import { ClickOutside } from "@dropbox/dig-components/click_outside";
import { type OverlayPlacement } from "@dropbox/dig-components/overlay";
import { Box } from "@dropbox/dig-foundations";
import { UIIcon } from "@dropbox/dig-icons";
import { InfoLine } from "@dropbox/dig-icons/assets";
import { DigTooltip as Tooltip } from "@mirage/shared/util/DigTooltip";
import i18n from "@mirage/translations";
import { useRef, useState } from "react";
import styles from "./DashTrialCTA.module.css";

type IconCTAProps = {
  adminName?: string;
  tooltipPlacement?: OverlayPlacement;
  tooltipVariant?: "withTitle" | "withoutTitle";
};

export const DashTrialCTAIcon = ({
  adminName,
  tooltipPlacement,
  tooltipVariant,
}: IconCTAProps) => {
  const [showMemberTooltip, setShowMemberTooltip] = useState(false);
  const triggerRef = useRef(null);

  let tooltipText = adminName
    ? i18n.t("ask_your_admin", { adminName: adminName })
    : i18n.t("ask_your_admin_backup");
  const showTitle = tooltipVariant === "withTitle";
  tooltipText = showTitle
    ? tooltipText
    : i18n.t("combined_member_tooltip_text", { adminName: adminName });

  const tooltipClassName =
    tooltipVariant === "withoutTitle"
      ? styles.dashTrialSmallTooltip
      : undefined;

  return (
    <div>
      {
        <IconButton
          ref={triggerRef}
          variant="borderless"
          shape="circular"
          onClick={() => setShowMemberTooltip(true)}
        >
          <UIIcon src={InfoLine} />
        </IconButton>
      }
      <Tooltip.Control
        variant="rich"
        open={showMemberTooltip}
        triggerRef={triggerRef}
        auto
        placement={tooltipPlacement ?? "bottom-end"}
      >
        <ClickOutside
          isBlock
          isActive
          shouldPropagateMouseEvents
          isClickThroughPortaled={false}
          onClickOutside={() => setShowMemberTooltip(false)}
        >
          <Box className={tooltipClassName}>
            {showTitle && (
              <Tooltip.Title>{i18n.t("want_to_keep_dash")}</Tooltip.Title>
            )}
            <Tooltip.Text withMargin={showTitle}>{tooltipText}</Tooltip.Text>
            {showTitle && (
              <Tooltip.Actions>
                <Button
                  variant="outline"
                  onClick={() => setShowMemberTooltip(false)}
                >
                  {i18n.t("got_it")}
                </Button>
              </Tooltip.Actions>
            )}
          </Box>
        </ClickOutside>
      </Tooltip.Control>
    </div>
  );
};
